import { render } from "./VuePage.vue?vue&type=template&id=389fc64f"
import script from "./VuePage.vue?vue&type=script&lang=js"
export * from "./VuePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__